module.exports = __webpack_public_path__ + "static/media/Blue-notifi.5c5cdc22.svg";